import { render, staticRenderFns } from "./show.vue?vue&type=template&id=3880e43d&"
import script from "./show.vue?vue&type=script&lang=js&"
export * from "./show.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3880e43d')) {
      api.createRecord('3880e43d', component.options)
    } else {
      api.reload('3880e43d', component.options)
    }
    module.hot.accept("./show.vue?vue&type=template&id=3880e43d&", function () {
      api.rerender('3880e43d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orders/show.vue"
export default component.exports